import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "playerSort" })
export class PlayerSortPipe implements PipeTransform {
  transform(array: any[] | null): any[] {
    if (!array) {
      return [];
    }
    return array.sort((a, b) => {
      if (a.finish && !b.finish) {
        return 1;
      }
      if (!a.finish && b.finish) {
        return -1;
      }
      if (a.finish && b.finish) {
        return a.finish - b.finish;
      }
      if (a.stack > b.stack) {
        return -1;
      }
      if (a.stack < b.stack) {
        return 1;
      }
      if (a.dispName.toUpperCase() < b.dispName.toUpperCase()) {
        return -1;
      }
      if (a.dispName.toUpperCase() > b.dispName.toUpperCase()) {
        return 1;
      }
      return 0;
    });
  }
}
